module.exports = __webpack_public_path__ + "img/ring_skip_0_null_0.fd4a1724.png";